type BoggleUnviewedListener = () => void

const listeners = new Set<BoggleUnviewedListener>()

export function subscribeBoggleUnviewedChanged(listener: BoggleUnviewedListener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function notifyBoggleUnviewedChanged() {
  for (const listener of listeners) {
    listener()
  }
}
